import initialState from '../../../../store/initialState';
import * as types from '../services/dailyReportActionType';

const dailyReportReducer = (state = initialState.dailyReport, action) => {
    switch (action.type) {
        case types.FETCH_DAILY_POWER_BI_REPORT_REQUEST:
            return { ...state, powerBiLoading: true, powerBiError: null };
        case types.FETCH_DAILY_POWER_BI_REPORT_SUCCESS:
            return { ...state, powerBiLoading: false, embedConfig: action.payload };
        case types.FETCH_DAILY_POWER_BI_REPORT_FAILURE:
            return { ...state, powerBiLoading: false, powerBiError: action.payload, embedConfig: null };
        case types.FETCH_DAILY_REPORT_LAST_REFRESHED_REQUEST:
            return { ...state, lastRefreshedLoading: true, lastRefreshedDateTime: null, nextRefreshDateTime: null, lastRefreshedError: null };
        case types.FETCH_DAILY_REPORT_LAST_REFRESHED_SUCCESS:
            return { ...state, lastRefreshedLoading: false, lastRefreshedDateTime: action.payload?.lastRefreshedDateTime ?? null, nextRefreshDateTime: action.payload?.nextRefreshDateTime ?? null };
        case types.FETCH_DAILY_REPORT_LAST_REFRESHED_FAILURE:
            return { ...state, lastRefreshedLoading: false, lastRefreshedDateTime: null, nextRefreshDateTime: null, lastRefreshedError: action.payload };

        default:
            return state;
    }
};

export default dailyReportReducer;
